import React from 'react';
import './Contact.css';

export default function Contact() {


    const [result, setResult] = React.useState("");

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending....");
        const formData = new FormData(event.target);

        formData.append("access_key", "33b7135b-cc40-414f-9821-f708214cf263");

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            setResult("Form Submitted Successfully");
            event.target.reset();
        } else {
            console.log("Error", data);
            setResult(data.message);
        }
    };

    return (
        <div className='contact-container'>
            <div className="content">
                <h3>Contact</h3>
                <div className='golden-bar'></div>
                <div className="contact-container-bottom">
                    <div className="map-container">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3524.802968486296!2d71.41484342696448!3d33.957830521539464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38d91077a279175b%3A0x736c91c08d717ed7!2sIM%7CSciences%20Hostel%201!5e1!3m2!1sen!2s!4v1724080796600!5m2!1sen!2s"
                            allowFullScreen=""
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Maps"
                            className='map'
                            style={{ width: "1160px", height: "450px", border: "0", borderRadius: '15px', filter: 'grayscale(100%)', floodColor: 'Black' }}
                        ></iframe>
                    </div>
                    <div className='form-container'>
                        <form onSubmit={onSubmit}>
                            <div className="inputs">
                                <input type="text" name="name" required placeholder='Full Name' />
                                <input type="email" name="email" required placeholder='Emial' />
                            </div>
                            <textarea name="message" required placeholder='Enter Message' rows={5}></textarea>

                            <button type="submit">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send" viewBox="0 0 16 16">
                                    <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
                                </svg>
                                Submit Form
                            </button>

                        </form>
                        <span>{result}</span>

                    </div>
                </div>
            </div>
        </div>
    );
}
